
import React, { useEffect } from 'react';
import {
    useDisclosure,
    AlertDialog,
    AlertDialogOverlay,
    AlertDialogContent,
    AlertDialogHeader,
    AlertDialogBody,
    AlertDialogFooter,
    Button
} from '@chakra-ui/react';
import axios from 'axios';

import packageJson from '../../package.json';
const currentAppVersion = packageJson.version;

/**
 * Compare two versions in the format 1.2.3. Returns true if versionB is greater than versionA.
 * @param {string} versionA 
 * @param {string} versionB 
 * @returns boolean
 */
const needRefresh = (versionA, versionB) => {
    const partsA = versionA.split('.').map(Number);
    const partsB = versionB.split('.').map(Number);
  
    for (let i = 0; i < 3; i++) {
      if (partsB[i] > partsA[i]) {
        return true;
      } else if (partsB[i] < partsA[i]) {
        return false;
      }
    }
  
    return false; // Both versions are equal
};

const AppVersion = () => {
    const { isOpen, onOpen, onClose } = useDisclosure();

    const checkVersion = async () => {
        const { data } = await axios.get('/meta.json');
        const latestVersion = data?.version;

        const needUpdate = needRefresh(currentAppVersion, latestVersion);

        if (needUpdate) {
            onOpen();
        }
    };

    useEffect(() => {
        checkVersion();

        // set up an interval that checks if the current app version is outdated
        const checkInterval = 10 * 60 * 1000; // 10 minutes
        const interval = setInterval(checkVersion, checkInterval);

        // cleanup
        return () => clearInterval(interval);
    }, []);

    // delete browser cache and reload
    const reload = () => {
        if (caches) {
            // clear service worker caches
            caches.keys().then(function(names) {
                for (let name of names) caches.delete(name);
            });
        }
        window.location.reload(true);
    };

    return (
        <AlertDialog
        isOpen={isOpen}
        onClose={onClose}
      >
        <AlertDialogOverlay>
            <AlertDialogContent mx={2}>
                <AlertDialogHeader fontSize='lg' fontWeight='bold'>
                    App Update
                </AlertDialogHeader>
                <AlertDialogBody>
                    A new version of this app has been published. Please refresh to load the latest experience. 
                </AlertDialogBody>
                <AlertDialogFooter>
                <Button colorScheme='teal' onClick={reload}>
                    Reload
                </Button>
                </AlertDialogFooter>
            </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    );
};

export default AppVersion;